import { motion } from 'framer-motion'
import { useEffect } from 'react'
import './FortuneLoadingScreen.css'
import logo from '../../assets/images/logoLoad.svg'

interface FortuneLoadingScreenProps {
  isLoading: boolean
  onComplete?: () => void
}

const FortuneLoadingScreen = ({
  isLoading,
  onComplete,
}: FortuneLoadingScreenProps) => {
  // Управление скроллом
  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = 'hidden'
      document.documentElement.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
      document.documentElement.style.overflow = ''
    }

    return () => {
      document.body.style.overflow = ''
      document.documentElement.style.overflow = ''
    }
  }, [isLoading])

  // Автоматическое завершение через 3.5 секунды
  useEffect(() => {
    if (isLoading && onComplete) {
      const timer = setTimeout(() => {
        onComplete()
      }, 3500)

      return () => clearTimeout(timer)
    }
  }, [isLoading, onComplete])

  if (!isLoading) return null

  return (
    <motion.div
      className="fortune-loading-screen loading-screen"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      {/* Снежинки */}
      <div className="snowflakes">
        {[...Array(15)].map((_, i) => (
          <div key={i} className={`snowflake snowflake-${i + 1}`}>
            ❅
          </div>
        ))}
      </div>

      {/* Основной контент */}
      <div className="loading-content">
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          <img src={logo} alt="logo" className="logo" />
        </motion.div>
        <motion.div
          className="loading-progress-container"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8, duration: 0.5 }}
        >
          <motion.div
            className="loading-progress"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.8, duration: 0.5 }}
          >
            <motion.div
              className="loading-progress-fill"
              initial={{ width: '0%' }}
              animate={{ width: '100%' }}
              transition={{
                delay: 1.2,
                duration: 3,
                ease: [0.25, 0.1, 0.25, 1], // Кубическая кривая для более реалистичного заполнения
              }}
            />
          </motion.div>
          <motion.p className="loading-button">загружаем...</motion.p>
        </motion.div>
      </div>
    </motion.div>
  )
}

export default FortuneLoadingScreen
